// Chinese (Simplified)
export const locale = {
  lang: 'zh',
  data: {
    CARD_FORM: {
      CARD_NUMBER: '卡号',
      EXPIRATION_DATE: '有效期',
      SECURITY_CODE: '安全码',
      INVALID_CARD_NUMBER: '卡号无效',
      CARD_NUMBER_REQUIRED: '请输入卡号',
      INVALID_EXPIRATION_DATE: '有效期无效',
      EXPIRATION_DATE_REQUIRED: '请输入有效期',
      CVC_REQUIRED: '请输入安全码',
      CVC_LENGTH_INVALID: '安全码长度无效',
      ZIP: '邮政编码',
      ZIP_REQUIRED: '请输入邮政编码',
      SAVE_FOR_FUTURE_PAYMENTS: '此付款方式将保存以用于未来付款。',
    },
    ERRORS: {
      AUTH_FAILED: '认证失败',
      MISSING_TOKEN: '缺少令牌参数',
      VALIDATION_FAILED: '验证失败',
      SERVER_ERROR: '服务器错误',
    },
  },
};

